import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ModuloService } from 'src/app/data/datasource/local/modulo.service';
import { Modulo } from '../sidebar/modulos';

/** Lanzador de módulos del header: muestra el módulo activo y permite cambiar a otro. */
@Component({
  selector: 'app-modulo-switcher',
  standalone: true,
  imports: [MaterialModule, TablerIconsModule],
  templateUrl: './modulo-switcher.component.html',
  styleUrls: ['./modulo-switcher.component.scss'],
})
export class ModuloSwitcherComponent {
  moduloService = inject(ModuloService);
  private router = inject(Router);

  abrir(m: Modulo): void {
    this.router.navigateByUrl(m.inicio);
  }
}
